'use strict';

require('./cn-file-upload.scss');

module.exports = {
  template: require('./cn-file-upload.html'),
  controller: require('./cn-file-upload.controller'),
  controllerAs: 'vm',

  bindings: {
    accept: '@',
    onSubmit: '&',
    onCancel: '&'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-file-upload/index.js
 ** module id = 88
 ** module chunks = 0
 **/